import configs from "@/i18n/configs"
export default {
    'toggle-customer-account-status': 'Toggle customer account status',
    'activated': 'Activated',
    'deactivated': 'Deactivated',
    'the-selected-customer-is-account': 'the selected customer is account',
    'edit-doctor': `${configs.editDoctor.en}`,
    'add-new-doctor': `${configs.addNewDoctor.en}`,
    'contact-information': 'Contact information',
    'addresses': 'Addresses',
    'merge-customer': 'Merge customer',
    'do-you-want-to-merge-the-customer-with-another-customer': 'Do you want to merge the customer with another customer',
    'modification-requests': 'Modification requests',
    'specializations': 'Specializations',
    'classification': 'Classification',
    'workload': 'Workload',
    'sort-by-name': 'Sort by name',
    'sort-by-classification': 'Sort by classification',
    titles: {
        doctors: `${configs.doctors.en}`,
        pharmacies: `${configs.pharmacies.en}`,
        centers: `${configs.centers.en}`
    },
    labels: {
        doctor: `${configs.doctor.en}`,
        pharmacy: `${configs.pharmacy.en}`,
        center: `${configs.center.en}`
    },
    'make-sure-you-have-entered-the-address-and-classification-please': 'Make sure you have entered the address and classification please',
    'delete-or-merge-customer': 'Delete or merge customer',
    'add-location': 'Add location',
    'the-client-has-been-created': 'The client has been created',
    'the-client-has-been-modified': 'The client has been modified',
    'there-is-a-similarity-in-name-with-another-customer': 'There is a similarity in name with another customer',
    'active': 'Active',
    'deactivate': 'Deactivate',
    'customers-types': 'Types of customers'
}